/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerAdminSettings.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Admin Settings
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, January 31, 2019 - 12:08 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      01/31/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    ADMINSETTING_LIST_CONTAINER_LOADED,
    ADMINSETTING_LIST_CONTAINER_UNLOADED,
    ADMINSETTING_LIST_TABLE_LOADED,
    ADMINSETTING_LIST_TABLE_UNLOADED,

    ADMINSETTING_LIST_CHANGE_GROUP,
    ADMINSETTING_SELECT_ROW,
    ADMINSETTING_ADD,
    ADMINSETTING_EDIT,
    ADMINSETTING_DELETE,
    ADMINSETTING_OPEN_WARNING,
    ADMINSETTING_CLOSE_WARNING,

    ADMINSETTING_EDIT_CONTAINER_LOADED,
    ADMINSETTING_EDIT_CONTAINER_UNLOADED,
    ADMINSETTING_EDIT_COMPANIES_LOADED,
    ADMINSETTING_EDIT_USERS_LOADED,
    ADMINSETTING_EDIT_BLOCKGROUP_LOADED,
    ADMINSETTING_EDIT_BLOCKTREE_LOADED,

    ADMINSETTING_UPDATE_VALUE,

    ADMINSETTING_EDIT_DRAW_COMPANYOPTIONS,
    ADMINSETTING_EDIT_DRAW_USEROPTIONS,
    ADMINSETTING_EDIT_DRAW_BLOCKTREE,
    ADMINSETTING_EDIT_BLOCKFORMAT_LOADED,
    ADMINSETTING_EDIT_FORM_LOADED,
    ADMINSETTING_EDIT_FORM_UNLOADED,
    ADMINSETTING_EDIT_DATA_LOAD,
    ADMINSETTING_EDIT_CONTAINER_SUBMIT,
    ADMINSETTING_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeAdminSettings';

const defaultState = {
    refreshList: false,
    danger: false,
    blockdataid: 0,
    companyid: 0,
    userid: 0,
    primarykeyid: 0,
    name: '',
    description: '',
    joinkey: '',
    createdate: '',
    modifydate: '',
    tagname: '',
    cmsselect: false
};

let result = null;

export default (state = defaultState, action) => {
    switch (action.type) {
        case ADMINSETTING_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                blockdatas: action.payload[0] ? action.payload[0].records : null,
                blockgroups: action.payload[1] ? action.payload[1].records : null
            }
        case ADMINSETTING_LIST_CHANGE_GROUP:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                blockdatas: action.payload[0] ? action.payload[0].records : null
            }
        case ADMINSETTING_LIST_TABLE_LOADED:
            return {
                ...state
            }

        case ADMINSETTING_SELECT_ROW:
            return {
                ...state,
                blockdataid: action.id
            }
        case ADMINSETTING_ADD:
            return {
                ...state
            }
        case ADMINSETTING_EDIT:
            return {
                ...state,
                blockdataid: action.id
            }
        case ADMINSETTING_DELETE:
            return {
                ...state,
                blockdataid: null
            }
        case ADMINSETTING_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case ADMINSETTING_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case ADMINSETTING_EDIT_CONTAINER_LOADED:
        case ADMINSETTING_EDIT_DATA_LOAD:
            result = {
                ...state,
                blockdataid: action.payload[0] ? action.payload[0].blockdataid : 0,
                blockgroupid: action.payload[0] ? action.payload[0].blockgroupid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                userid: action.payload[0] ? action.payload[0].userid : 0,
                primarykeyid: action.payload[0] ? action.payload[0].primarykeyid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                joinkey: action.payload[0] ? action.payload[0].joinkey : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''                
            }
            if (action.payload[0] && action.payload[0].customFields) {
                result['customFields'] = action.payload[0].customFields
            }
            return result;
        case ADMINSETTING_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case ADMINSETTING_EDIT_COMPANIES_LOADED:
            return {
                ...state,
                companies: action.payload ? action.payload.companies : []
            }
        case ADMINSETTING_EDIT_USERS_LOADED:
            return {
                ...state,
                users: action.payload ? action.payload.users : []
            }
        case ADMINSETTING_EDIT_BLOCKGROUP_LOADED:
            return {
                ...state,
                blockgroup: action.payload ? action.payload.name : ''
            }
        case ADMINSETTING_EDIT_BLOCKTREE_LOADED:
            return {
                ...state,
                blocktree: action.payload ? action.payload.records : []
            }
        case ADMINSETTING_EDIT_DRAW_COMPANYOPTIONS:
            return {
                ...state,
                companyOptions: action.payload ? action.payload : null
            }
        case ADMINSETTING_EDIT_DRAW_USEROPTIONS:
            return {
                ...state,
                userOptions: action.payload ? action.payload : null
            }
        case ADMINSETTING_EDIT_DRAW_BLOCKTREE:
            return {
                ...state,
                blockTreeDisplay: action.payload ? action.payload : null
            }
        case ADMINSETTING_EDIT_BLOCKFORMAT_LOADED:
            return {
                ...state,
                blockformat: action.payload ? action.payload.records : []
            }
        case ADMINSETTING_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case ADMINSETTING_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case ADMINSETTING_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case ADMINSETTING_LIST_CONTAINER_UNLOADED:
        case ADMINSETTING_LIST_TABLE_UNLOADED:
        case ADMINSETTING_EDIT_CONTAINER_UNLOADED:
        case ADMINSETTING_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerAdminSettings.js